import React, { useEffect, useRef } from 'react';
import { BONI_CHECKBOX_CLASSNAME } from '../../../../constants/brandColors';

type ToggleRowProps = {
  label: React.ReactNode;
  checked: boolean;
  indeterminate?: boolean;
  onChange: (checked: boolean) => void;
  icon?: React.ReactNode;
};

const ToggleRow: React.FC<ToggleRowProps> = ({
  label,
  checked,
  indeterminate = false,
  onChange,
  icon,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <label className="flex flex-row items-center pb-4">
      {icon && <div className="flex h-8 items-center border border-r-0 rounded-sm px-1 py-1">{icon}</div>}
      <input
        ref={inputRef}
        className={BONI_CHECKBOX_CLASSNAME}
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
      />
      &nbsp;{label}
    </label>
  );
};

export default ToggleRow;
